module.exports = __webpack_public_path__ + "static/media/store-custom.a99bb6e7.svg";